export default __webpack_public_path__ + "static/media/080_finish_soso.last.19f3757a.webp";